import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useToast } from "../helpers/hooks";
import { UserProps } from "../interfaces/app";
import { useAuthModal } from "../context/AuthModalContext";

export const ProtectedRoute = ({ user, children }: { user: UserProps | null, children: JSX.Element }) => {
	const toast = useToast();
	const location = useLocation();
	const { handleOpenAuthModal } = useAuthModal();

	useEffect(() => {
		if (!user) {
			toast("Debes iniciar sesión");
			handleOpenAuthModal();
		}
	}, [user]);

	if (!user) {
		return <Navigate to="/" state={{ from: location }} replace />;
	}
	return children;
};
